import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import RequireAuth from './auth/RequireAuth';
import AdminLayout from './layouts/AdminLayout';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import PlaceholderPage from './pages/PlaceholderPage';
import OnboardingConfigPage from './pages/OnboardingConfigPage';
import UsersPage from './pages/UsersPage';
import UserProfilePage from './pages/UserProfilePage';
import CouponsPage from './pages/CouponsPage';
import GasStationsPage from './pages/GasStationsPage';
import FeedbackPage from './pages/FeedbackPage';
import ScansPage from './pages/ScansPage';
import ScanDetailsPage from './pages/ScanDetailsPage';
import ErrorBoundary from './components/ui/ErrorBoundary';
import { NAV_ITEMS } from './components/layout/navItems';

const BUILT_ROUTES = ['/onboarding-config', '/users', '/coupons', '/gas-stations', '/feedback', '/scan-details'];

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />

        <Route element={<RequireAuth />}>
          <Route element={<AdminLayout />}>
            {/* Screens are swapped in here as they're built */}
            <Route path="/onboarding-config" element={<OnboardingConfigPage />} />
            <Route
              path="/users"
              element={
                <ErrorBoundary title="The Users screen hit an error">
                  <UsersPage />
                </ErrorBoundary>
              }
            />
            <Route
              path="/gas-stations"
              element={
                <ErrorBoundary title="The Gas Stations screen hit an error">
                  <GasStationsPage />
                </ErrorBoundary>
              }
            />
            <Route
              path="/scan-details"
              element={
                <ErrorBoundary title="The Scans screen hit an error">
                  <ScansPage />
                </ErrorBoundary>
              }
            />
            <Route
              path="/scan-details/:id"
              element={
                <ErrorBoundary title="The Scan Details screen hit an error">
                  <ScanDetailsPage />
                </ErrorBoundary>
              }
            />
            <Route
              path="/feedback"
              element={
                <ErrorBoundary title="The Feedback screen hit an error">
                  <FeedbackPage />
                </ErrorBoundary>
              }
            />
            <Route
              path="/coupons"
              element={
                <ErrorBoundary title="The Coupons screen hit an error">
                  <CouponsPage />
                </ErrorBoundary>
              }
            />
            <Route
              path="/users/:userId"
              element={
                <ErrorBoundary title="The user profile hit an error">
                  <UserProfilePage />
                </ErrorBoundary>
              }
            />
            {NAV_ITEMS.filter((item) => !BUILT_ROUTES.includes(item.to)).map((item) => (
              <Route key={item.to} path={item.to} element={<PlaceholderPage title={item.label} />} />
            ))}
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/scan-details" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
